import { MutationTree } from 'vuex';
import { State, IloginInfo } from './state';

const mutations: MutationTree<State> = {
  setUserInfo(state, loginInfo: IloginInfo) {
    state.baseInfo = loginInfo.baseInfo;
    state.accountInfo = loginInfo.accountInfo;
    state.cancelInfo = loginInfo.cancelInfo;
    localStorage.setItem('login-user-info', JSON.stringify(loginInfo));
  },
};

export default mutations;
